import { cn } from '@quadralize/utils'
import * as ProgressPrimitive from '@radix-ui/react-progress'
import * as React from 'react'

const MAX_PROGRESS = 100
const MIN_PROGRESS = 0

const Progress = React.forwardRef<
  React.ComponentRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>
>(({ className, value, ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={cn('relative h-4 w-full overflow-hidden rounded-full bg-bg-subtle', className)}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className="h-full w-full flex-1 bg-primary transition-all"
      style={{
        transform: `translateX(-${MAX_PROGRESS - Math.min(Math.max(value || MIN_PROGRESS, MIN_PROGRESS), MAX_PROGRESS)}%)`,
      }}
    />
  </ProgressPrimitive.Root>
))
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
